import { useEffect } from "react";
import PageHead from "@/components/PageHead";
// eslint-disable-next-line import/no-unresolved
import rawHtml from "./share/getting-to-regatta-beach.html?raw";

/**
 * Standalone, unlisted page rendered as-is from a self-contained HTML document.
 * - Hidden from navigation, internal links, and sitemap
 * - noindex/nofollow via meta robots
 * - No site chrome (Navbar/Footer) — renders the original HTML body + styles
 */
const ShareGettingToRegattaBeach = () => {
  const styleMatch = rawHtml.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
  const bodyMatch = rawHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  const styleContent = styleMatch ? styleMatch[1] : "";
  const bodyContent = bodyMatch ? bodyMatch[1] : rawHtml;

  // Scope the CSS to this page's container so it doesn't leak globally,
  // and load the Google Fonts used by the original document.
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <PageHead
        title="Getting to Regatta Beach — 6 June 2026 | QbD Group"
        meta={[
          { name: "robots", content: "noindex, nofollow" },
          { name: "googlebot", content: "noindex, nofollow" },
        ]}
      />
      <style dangerouslySetInnerHTML={{ __html: styleContent }} />
      <div dangerouslySetInnerHTML={{ __html: bodyContent }} />
    </>
  );
};

export default ShareGettingToRegattaBeach;
